export const namespace = 'dialogStatus';

export const ActionTypes = {
  OPEN_DIALOG: `${namespace}/OPEN_DIALOG`,
  CLOSE_DIALOG: `${namespace}/CLOSE_DIALOG`
}

export const Status = {
  STATUS_OPEN: 'open',
  STATUS_CLOSE: 'close',
};

export const openDialog = (dialogName, value) => ({
  type: ActionTypes.OPEN_DIALOG,
  payload: {
    dialogName,
    value
  }
})

export const closeDialog = (dialogName, value) => ({
  type: ActionTypes.CLOSE_DIALOG,
  payload: {
    dialogName,
    value
  }
})